import { render, staticRenderFns } from "./NavV2.vue?vue&type=template&id=4303c602&scoped=true"
import script from "./NavV2.vue?vue&type=script&lang=ts"
export * from "./NavV2.vue?vue&type=script&lang=ts"
import style0 from "./NavV2.vue?vue&type=style&index=0&id=4303c602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4303c602",
  null
  
)

export default component.exports